

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {TranslateResult} from "vue-i18n";

@Component({
  name: 'DateFormComponent'
})
export default class BoDateField extends Vue {

  @Prop()
  protected value!: '';

  // it WONT work with propSync and I don't really care why
  // @PropSync('value')
  // private value!: string;

  @Prop()
  private label!: TranslateResult;

  @Prop()
  private disabled!: boolean;

  @Prop({ default: null })
  private errorMessages!: any;

  protected showDatePicker: boolean = false;

  protected onShowDatePicker() {
    this.showDatePicker = true;
  }

  protected onInput(newValue: string) {
    this.$emit('input', newValue);
  }

  protected onDatePicked(newValue: string) {
    this.showDatePicker = false;
    this.$emit('input', newValue);
  }

}

